import { jsx as i } from "react/jsx-runtime";
import l from "react";
import { e as c } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import g, { css as a } from "styled-components";
const o = {
  Neutral: "neutral",
  Informative: "informative",
  Positive: "positive",
  Warning: "warning",
  Negative: "negative"
};
Object.values(o);
const v = g.div.withConfig({
  displayName: "Tag",
  componentId: "sc-y5j7ek-0"
})(["", " width:fit-content;display:inline-flex;padding:var(--spacing-none) var(--spacing-1x);justify-content:center;align-items:center;border-radius:var(--border-radius-circular);height:var(--size-3x);", ""], c, (r) => r.type && s(r.type)), s = (r) => {
  if (r === o.Neutral)
    return a(["background-color:var(--elements-bg-color-02);color:var(--on-text-label-color);"]);
  if (r === o.Positive)
    return a(["background-color:var(--positive-bg-color-02);color:var(--on-positive-label-color);"]);
  if (r === o.Informative)
    return a(["background-color:var(--informative-bg-color-02);color:var(--on-informative-label-color);"]);
  if (r === o.Warning)
    return a(["background-color:var(--warning-bg-color-02);color:var(--on-warning-label-color);"]);
  if (r === o.Negative)
    return a(["background-color:var(--negative-bg-color-02);color:var(--on-negative-label-color);"]);
}, d = l.forwardRef(({
  type: r = o.Neutral,
  children: e,
  ...n
}, t) => /* @__PURE__ */ i(v, { type: r, ref: t, "data-testid": "rango-tag", "data-rango-component": "rango-tag", "data-is-rango": !0, ...n, children: e }));
d.displayName = "RangoTag";
export {
  d as RangoTag,
  o as TagType
};
